import { useQuery } from '@tanstack/react-query';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { AISettings } from '@/UI/Identity/ConversationStyle/ConversationStyle.page';
import { LanguageSettingPage } from '@/UI/Identity/LanguageSetting/LanguageSetting.page';

export const LanguageSettingLoader = () => {
  const { data, isLoading } = useQuery<AISettings>({ queryKey: ['settings'] });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <LanguageSettingPage data={data!} />;
};
